import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgAcneFiveGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.056c-1.116 0-2.02-.91-2.02-2.033C21.98 8.9 22.884 8 24 8s2.02.91 2.02 2.023A2.039 2.039 0 0 1 24 12.056Zm0-2.846a.818.818 0 1 0 0 1.635.818.818 0 0 0 0-1.635ZM24 40c-1.116 0-2.02-.91-2.02-2.033 0-1.123.904-2.023 2.02-2.023s2.02.91 2.02 2.023S25.106 40 24 40Zm0-2.846a.818.818 0 1 0 .818.813.83.83 0 0 0-.818-.813Zm11.969-13.26c0 1.122.895 2.032 2.01 2.032 1.107 0 2.021-.92 2.021-2.032a2.03 2.03 0 0 0-2.02-2.023c-1.107 0-2.011.9-2.011 2.023Zm1.202 0a.81.81 0 0 1 .809-.813.83.83 0 0 1 .817.813.826.826 0 0 1-.817.822.818.818 0 0 1-.809-.822Zm-27.15 2.032c-1.117 0-2.021-.91-2.021-2.032 0-1.123.904-2.023 2.02-2.023 1.117 0 2.02.91 2.02 2.023a2.039 2.039 0 0 1-2.02 2.032Zm0-2.845a.818.818 0 1 0 .817.813.83.83 0 0 0-.817-.813Zm11.959.813c0 1.122.904 2.032 2.02 2.032 1.106 0 2.02-.92 2.02-2.032A2.024 2.024 0 0 0 24 21.87c-1.116 0-2.02.9-2.02 2.023Zm1.202 0c0-.446.366-.813.818-.813a.83.83 0 0 1 .818.813.82.82 0 0 1-.818.822.82.82 0 0 1-.818-.822Z",
    fill: "currentColor"
  }));
}

export { SvgAcneFiveGlyph as default };
